import { render, staticRenderFns } from "./RestaurantOpeningHours.vue?vue&type=template&id=7e74ced5&scoped=true&"
import script from "./RestaurantOpeningHours.vue?vue&type=script&lang=js&"
export * from "./RestaurantOpeningHours.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantOpeningHours.vue?vue&type=style&index=0&id=7e74ced5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e74ced5",
  null
  
)

export default component.exports